<template>
  <div class="card">
    <div class="card-body mb-5">
      <p class="mb-4">
        <small class="font-weight-bold">{{ $t('dashboard.risk') }}</small>
      </p>
      <div
        v-if="error"
        class="text-danger"
      >
        {{ error }}
      </div>
      <div
        v-else
        class="d-flex justify-content-around px-1"
      >
        <Bar
          :name="$t('dashboard.risk-label.high')"
          color-one="#FF0000"
          color-two="#B80101"
          :value="riskLevel.high"
          :total="riskLevel.totalSubmission"
        />
        <Bar
          :name="$t('dashboard.risk-label.medium')"
          color-one="#FF7A00"
          color-two="#D68205"
          :value="riskLevel.medium"
          :total="riskLevel.totalSubmission"
        />
        <Bar
          :name="$t('dashboard.risk-label.low')"
          color-one="#00FF38"
          color-two="#25B801"
          :value="riskLevel.low"
          :total="riskLevel.totalSubmission"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { format, sub } from 'date-fns'
import Api from '@/utils/Api'
import Bar from '@/components/chart/Bar.vue'

export default {
  components: {
    Bar
  },

  props: {
    filters: {
      type: Object,
      default: () => ({
        period: 'daily',
        startDate: sub(new Date(), { days: 30 }),
        endDate: new Date()
      })
    },
    isApply: {
      type: Boolean,
      default: () => (false)
    }
  },

  data: () => ({
    riskLevel: {
      high: 0,
      low: 0,
      medium: 0,
      totalSubmission: 0
    },
    error: ''
  }),

  computed: {
    builtFilters () {
      return [
        `period=${this.filters.period}`,
        `startDate=${format(this.filters.startDate, 'yyyy-MM-dd')}`,
        `endDate=${format(this.filters.endDate, 'yyyy-MM-dd')}`,
        ...this.filters.organization.map(organization => `organization=${organization}`),
        ...this.filters.workLocation.map(workLocation => `workLocation=${workLocation}`),
        ...this.filters.employee.map(employee => `employeeType=${employee}`),
        ...this.filters.contractors.map(contractors => `contractorId=${contractors}`),
        ...this.filters.risk.map(risk => `risk=${risk}`)
      ].join('&')
    }
  },

  watch: {
    'filters.contractors': {
      deep: true,
      immediate: true,
      handler: 'fetch'
    },
    isApply: {
      deep: true,
      immediate: true,
      handler: 'fetch'
    }
  },

  created () {
    this.fetch()
  },

  methods: {
    async fetch () {
      try {
        this.error = ''
        const { data } = await Api.dashboard.riskLevel(this.builtFilters)
        this.riskLevel = data
      } catch {
        this.error = 'Error'
      }
    }
  }
}
</script>
